import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "300px"
  },
  rootFormControl: {
    width: "300px"
  }
}));